import * as React from 'react';

import { Card } from 'antd';

import type IProduct from 'interfaces/IProduct';
import type { ProductOffer } from 'v2/interfaces/product';

import { LinksModal } from './LinksModal';
import { List } from './List';

type OffersProps = {
  isAffiliate: boolean;
  product: IProduct;
};

export function Offers({ isAffiliate, product }: OffersProps) {
  const [offer, setOffer] = React.useState<ProductOffer | undefined>(undefined);
  const [isLinksModalOpen, setIsLinksModalOpen] = React.useState(false);

  const handleLinksClick = React.useCallback((offer: ProductOffer) => {
    setOffer(offer);
    setIsLinksModalOpen(true);
  }, []);

  return (
    <Card title='Ofertas' className='mt-5 max-w-full'>
      <div className='max-sm:px-2 max-sm:py-6'>
        <List isAffiliate={isAffiliate} productId={product.id} handleLinksClick={handleLinksClick} />
      </div>
      {offer && (
        <LinksModal
          isAffiliate={isAffiliate}
          isOpen={isLinksModalOpen}
          closeModal={() => setIsLinksModalOpen(false)}
          offer={offer}
        />
      )}
    </Card>
  );
}
